export * from './annualit.service';
import { AnnualitService } from './annualit.service';
export * from './assistenza.service';
import { AssistenzaService } from './assistenza.service';
export * from './autenticazione.service';
import { AutenticazioneService } from './autenticazione.service';
export * from './dataEOra.service';
import { DataEOraService } from './dataEOra.service';
export * from './email.service';
import { EmailService } from './email.service';
export * from './menu.service';
import { MenuService } from './menu.service';
export * from './pagoPAWebhook.service';
import { PagoPAWebhookService } from './pagoPAWebhook.service';
export * from './passkeyWebAuthn.service';
import { PasskeyWebAuthnService } from './passkeyWebAuthn.service';
export * from './pastiDaPreparare.service';
import { PastiDaPreparareService } from './pastiDaPreparare.service';
export * from './ricariche.service';
import { RicaricheService } from './ricariche.service';
export * from './scuole.service';
import { ScuoleService } from './scuole.service';
export * from './sincronizzazioni.service';
import { SincronizzazioniService } from './sincronizzazioni.service';
export * from './studenti.service';
import { StudentiService } from './studenti.service';
export * from './utenti.service';
import { UtentiService } from './utenti.service';
export const APIS = [AnnualitService, AssistenzaService, AutenticazioneService, DataEOraService, EmailService, MenuService, PagoPAWebhookService, PasskeyWebAuthnService, PastiDaPreparareService, RicaricheService, ScuoleService, SincronizzazioniService, StudentiService, UtentiService];
